/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class Command {
    /**
     * Builds a command. Either the 'state' property or the 'handler' property shall be set.
     *
     * @param {Object} data Command properties:
     * <ul>
     * <li>title: command title key (will be translated).</li>
     * <li>iconUrl: URL of an icon.</li>
     * <li>[state]: name of a target state.</li>
     * <li>[stateParams]: optional parameters for the target state.</li>
     * <li>[handler]: optional command handler.</li>
     * <li>[only]: optional role or array of roles that are permitted to view this command.</li>
     * </ul>
     */
    constructor(data) {
        Object.assign(this, data);
    }

    static stateCommand(title, iconUrl, state, only, stateParams) {
        return new Command({
            title,
            iconUrl,
            state,
            only,
            stateParams
        });
    }

    static handlerCommand(title, iconUrl, handler, only, disabledProperty) {
        let disabled;
        if (disabledProperty) {
            disabled = "$ctrl.disabled."  + disabledProperty;
        }
        return new Command({
            title,
            iconUrl,
            handler,
            only,
            disabled
        });
    }
}

export { Command };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/Command.js